import React, { FC } from 'react';

import { cn } from 'utils';

import styles from './PackageDetails.module.scss';

const TOTAL_DOTS = 10;

type Props = {
  projectsCount: number;
};

export const PackageDealsProgress: FC<Props> = ({ projectsCount }) => {
  const filledCount = Math.min(Math.max(projectsCount, 0), TOTAL_DOTS);

  return (
    <div className={styles.progressCard}>
      <div className={styles.progressTrack}>
        {Array.from({ length: TOTAL_DOTS }, (_, index) => {
          const isFilled = index < filledCount;
          const isFirstFilled = index === 0 && isFilled;
          const isLast = index === TOTAL_DOTS - 1;
          const isLineCompleted = index < filledCount - 1;

          return (
            <div key={index} className={styles.progressStep}>
              <div
                className={cn(
                  styles.progressDot,
                  isFirstFilled && styles.progressDotFirst,
                  isFilled && !isFirstFilled && styles.progressDotCompleted,
                  !isFilled && styles.progressDotPending
                )}
              />
              {!isLast ? (
                <div className={styles.progressLine}>
                  <span
                    className={cn(
                      styles.progressLineRail,
                      isLineCompleted && styles.progressLineRailCompleted
                    )}
                  />
                  <span
                    className={cn(
                      styles.progressLineRail,
                      isLineCompleted && styles.progressLineRailCompleted
                    )}
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};
